import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import DownloadButtonIcon from '../../assets/svg/downloadButtonIcon.svg';

interface DownloadReportButtonProps {
  handleButtonClicked: () => void;
  isDownloading: boolean;
}

const DownloadReportButton = ({
  handleButtonClicked,
  isDownloading,
}: DownloadReportButtonProps) => (
  <Button
    variant='contained'
    onClick={handleButtonClicked}
    sx={{
      height: '2rem',
      padding: '0.85rem',
      borderRadius: '4px',
      gap: '0.625rem',
      backgroundColor: '#E0F9F9',
      '&:hover': {
        backgroundColor: '#c0f3f3',
      },
      '& .MuiButton-startIcon': {
        marginRight: '0px',
      },
      textTransform: 'none',
    }}
    startIcon={<img src={DownloadButtonIcon} alt='' />}
    disableElevation
    disabled={isDownloading}
  >
    <Typography
      sx={{
        fontFamily: 'Schibsted Grotesk',
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: '17px',
        letterSpacing: '0em',
        color: '#00CECF',
        my: '0.5rem',
        display: { xs: 'none', sm: 'initial' },
      }}
    >
      {isDownloading ? 'Downloading...' : 'Download Report'}
    </Typography>
  </Button>
);

export default DownloadReportButton;
